/** Decimal places for unit price / per-unit tax in document API payloads (sales, purchases, POS). */
export const FINANCIAL_PAYLOAD_DECIMAL_PLACES = 6;

/** Decimal places for payment amounts in payloads (currency display). */
export const PAYMENT_AMOUNT_DECIMAL_PLACES = 2;

/** Backend tax aggregate precision (DocumentFinancialMath). */
export const TAX_AGGREGATE_DECIMAL_PLACES = 4;

/** Round half away from zero at a fixed decimal scale (payload tax amounts). */
export function roundAwayFromZero(value: number, decimalPlaces: number): number {
  if (value === 0 || !Number.isFinite(value)) {
    return 0;
  }
  const factor = 10 ** decimalPlaces;
  const scaled = value * factor;
  return (Math.sign(scaled) * Math.round(Math.abs(scaled))) / factor;
}

/**
 * Half-up rounding to a fixed number of decimal places (same spirit as Math.round at scale).
 */
export function roundDecimalHalfUp(value: number, decimalPlaces: number): number {
  if (value === 0 || !Number.isFinite(value)) {
    return 0;
  }
  const multiplier = Math.pow(10, decimalPlaces);
  return Math.round(value * multiplier) / multiplier;
}
